import { useEffect, RefObject } from "react"

// ============================================================================
// JADVALNI SICHQONCHA BILAN USHLAB SURISH (tog'a, guruh #737, 2026-09-02)
// «Tizimning barcha razdel jadvallari mishkada ushlab yonga/pastga surish
//  imkoni bo'lsin — ma'lumot ko'payib ketganda skroll qilish qiyin.»
//
// Ishlash tartibi:
//  • chap tugma bosilib SURILSA — gorizontal: jadvalning ichki scroll
//    konteyneri (.ant-table-content / .ant-table-body), vertikal: sahifa
//  • 6px dan kam siljish — oddiy klik (qator tanlash, tugma) buzilmaydi
//  • tugma / havola / input / checkbox / select ustida boshlangan bosish —
//    e'tiborsiz (ular o'z ishini qiladi)
//  • surish paytida matn belgilanmaydi (user-select) va surishdan keyingi
//    birinchi klik yutiladi (tasodifiy qator ochilib ketmasin)
// Delegatsiya: bitta hook — sahifadagi BARCHA jadvallar uchun (TableExtended ildizi).
// ============================================================================

// Havola (a) va label ATAYLAB yo'q: ko'p jadvallarda katak matni havola — ular ustida ham surish
// boshlanishi kerak; surilgan bo'lsa klik baribir yutiladi (pastda), surilmasa havola ochiladi.
// .ant-btn-link (havola ko'rinishidagi tugma — masalan kontragent nomi) ham surishga ruxsat: o'lchov
// ko'rsatdi, ko'p jadvallarda katak matni aynan shu; surilmasa klik odatdagidek ishlaydi.
const INTERACTIVE = "button:not(.ant-btn-link), input, textarea, select, .ant-checkbox, .ant-select, .ant-btn:not(.ant-btn-link), .ant-pagination, .ant-dropdown-trigger, .ant-switch, [role=button]:not(.ant-btn-link), [contenteditable=true]"
const SCROLLER = ".ant-table-content, .ant-table-body"
const THRESHOLD = 6

/** rootRef berilmasa — butun hujjat (layout darajasida BIR MARTA ulanadi). */
export function useDragScroll(rootRef?: RefObject<HTMLElement>) {
  useEffect(() => {
    const root: HTMLElement | Document | null = rootRef ? rootRef.current : document
    if (!root) return

    let scroller: HTMLElement | null = null
    let startX = 0, startY = 0, startLeft = 0, startPageY = 0
    let dragging = false, moved = false

    const onDown = (e: MouseEvent) => {
      if (e.button !== 0) return
      const t = e.target as HTMLElement
      if (!t || t.closest(INTERACTIVE)) return
      const s = t.closest(SCROLLER) as HTMLElement | null
      if (!s) return
      scroller = s
      dragging = true; moved = false
      startX = e.clientX; startY = e.clientY
      startLeft = s.scrollLeft
      startPageY = window.scrollY
    }
    const onMove = (e: MouseEvent) => {
      if (!dragging || !scroller) return
      const dx = e.clientX - startX, dy = e.clientY - startY
      if (!moved && Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return
      if (!moved) {
        moved = true
        document.body.classList.add("drag-scrolling")
      }
      scroller.scrollLeft = startLeft - dx
      window.scrollTo({ top: startPageY - dy })
      e.preventDefault()
    }
    const end = () => {
      if (!dragging) return
      dragging = false
      if (moved) {
        // surishdan keyingi birinchi klikni yutamiz (qator/tugma tasodifan bosilmasin)
        const swallow = (ev: MouseEvent) => { ev.stopPropagation(); ev.preventDefault() }
        window.addEventListener("click", swallow, { capture: true, once: true })
        setTimeout(() => window.removeEventListener("click", swallow, { capture: true } as any), 0)
      }
      document.body.classList.remove("drag-scrolling")
      scroller = null; moved = false
    }

    // <a href> / rasm ustida surish boshlansa brauzer o'zining drag-and-drop'ini ishga tushiradi va
    // mousemove kelmay qoladi (o'lchov: /counterparties 20px da to'xtardi) — surish paytida bekor qilamiz
    const onDragStart = (e: Event) => { if (dragging) e.preventDefault() }

    root.addEventListener("dragstart", onDragStart)
    root.addEventListener("mousedown", onDown as EventListener)
    window.addEventListener("mousemove", onMove)
    window.addEventListener("mouseup", end)
    window.addEventListener("blur", end)
    return () => {
      root.removeEventListener("dragstart", onDragStart)
      root.removeEventListener("mousedown", onDown as EventListener)
      window.removeEventListener("mousemove", onMove)
      window.removeEventListener("mouseup", end)
      window.removeEventListener("blur", end)
      document.body.classList.remove("drag-scrolling")
    }
  }, [rootRef])
}
